import { render, staticRenderFns } from "./DelMenu.vue?vue&type=template&id=d3361e7c&scoped=true"
import script from "./DelMenu.vue?vue&type=script&lang=js"
export * from "./DelMenu.vue?vue&type=script&lang=js"
import style0 from "./DelMenu.vue?vue&type=style&index=0&id=d3361e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3361e7c",
  null
  
)

export default component.exports